export default __webpack_public_path__ + "static/media/bg-home.f6846ff9.jpg";